import React, { useEffect } from 'react';
import ContactSection from '../components/ContactSection';

const ContactPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <ContactSection isPage={true} />
        </div>
    );

};

export default ContactPage;
